import NumOfBetsController from '../../controllers/autospin/NumOfBetsController';
import AutoSpinController from '../../controllers/autospin/AutoSpinController';
import AutoSpinCheckBoxController from '../../controllers/autospin/AutoSpinCheckBoxController';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { AutoSpinViewGrid } from './AutoSpinViewGrid';
import CloseController from '../../controllers/CloseController';
import { isDesktop } from 'react-device-detect';

let scale = isDesktop ? 1 : 2;
export const AutoSpinView = {
	name: COMPONENTS.AUTO_SPIN,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: AutoSpinController,
			name: 'AutoSpinController',
			config: {
				item: 'autospin_btn',
				val: 'autospin_btn',
				holder: 'auto_spin_bg'
			}
		},
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: AutoSpinCheckBoxController,
			name: 'AutoSpinController',
			config: {
				item: 'auto_spin_bg',
				val: 'auto_spin_bg'
			}
		},
		{
			Controller: NumOfBetsController,
			name: 'NumOfBetsController',
			config: {
				item: 'numOfBets',
				numbers: [
					{
						item: 'num_10',
						position: { x: 0, y: 0 },
						text: '10',
						val: '10'
					},
					{
						item: 'num_50',
						position: { x: 93, y: 0 },
						text: '50',
						val: '50'
					},
					{
						item: 'num_100',
						position: { x: 186, y: 0 },
						text: '100',
						val: '100'
					},
					{
						item: 'num_500',
						position: { x: 279, y: 0 },
						text: '500',
						val: '500'
					},
					{
						item: 'num_1000',
						position: { x: 372, y: 0 },
						text: '1000',
						val: '1000'
					},
					{
						item: 'num_0',
						position: { x: 465, y: 0 },
						text: '',
						val: ''
					}
				],
				colors: {
					active: '#7BA21C',
					inactive: '#7571CA'
				},
				position: { x: 0, y: 0 },
				img: {
					active: 'infinity_symbol_activated',
					inactive: 'infinity_symbol'
				}
			}
		},
		{
			Controller: MainGridController,
			name: 'MainGridController',
			config: AutoSpinViewGrid
		}
	],
	components: [
		{
			name: 'auto_spin_bg',
			type: 'Sprite',
			components: [
				{
					name: 'auto_spin_bg1',
					type: 'Sprite',
					img: 'autospin_bg',
					scale: { x: scale, y: scale }
				},
				{
					name: 'auto_spin_title',
					type: 'Text',
					text: 'AUTOSPIN_HEADER',
					position: { x: 130, y: 30 }
				},
				{
					name: 'close',
					type: 'ActionButton',
					position: { x: 560, y: 20 },
					components: [
						{
							name: 'xxxxx',
							type: 'MouseOverSprite',
							img: 'close_icon',
							imgHover: 'close_icon_hovered',
							scale: {
								x: 1.2,
								y: 1.2
							}
						}
					]
				},
				{
					name: 'auto_spin_anim_cb',
					type: 'Button',
					components: [
						{
							name: 'auto_spin_anim_checkbox',
							type: 'SwitchButton',
							bg: 'checkbox_inactive',
							fg: 'checkbox_active',
							position: { x: 75, y: 132 }
						},
						{
							name: 'auto_spin_anim_text',
							type: 'SwitchButton',
							text: 'AUTOSPIN_ANIM_TEXT',
							position: { x: 110, y: 127 }
						}
					]
				},
				{
					name: 'auto_spin_fast_cb',
					type: 'Sprite',
					components: [
						{
							name: 'auto_spin_fast_checkbox',
							type: 'SwitchButton',
							bg: 'checkbox_inactive',
							fg: 'checkbox_active',
							position: { x: 385, y: 132 }
						},
						{
							name: 'auto_spin_fast_text',
							type: 'SwitchButton',
							text: 'AUTOSPIN_FAST_TEXT',
							position: { x: 420, y: 127 }
						}
					]
				},
				{
					name: 'auto_number_of_spins_text',
					type: 'Text',
					text: 'AUTOSPIN_NUMBEROFSPIN_TEXT',
					position: { x: 185, y: 215 }
				},
				{
					name: 'numOfBets',
					position: { x: 43, y: 292 },
					type: 'Sprite',
					components: [
						{
							name: 'num_10',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_50',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_100',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_500',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_1000',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_0',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 }
						}
					]
				},
				{
					name: 'autospin_btn',
					type: 'ActionButton',
					bg: 'auto_modal_btn',
					text: 'AUTOSPIN_BTN',
					position: { x: 317, y: 430 }
				}
			]
		}
	]
};
